import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { EsignEnvelope } from '/@/modules/esign/models/EsignEnvelope';

export class EsignEnvelopeCollection extends ModelCollection {
  /**
   * @param {array} items
   */
  constructor(items = null) {
    super(items, EsignEnvelope);
  }

  /**
   * @param {array|DocumentCollection|null} items
   * @returns {EsignEnvelopeCollection}
   */
  static mapModel(items = null) {
    return new this(items, EsignEnvelope);
  }

  /**
   * @param {number} userId
   * @returns {number}
   */
  getUnreadCount(userId) {
    let unreadCount = 0;
    const items = this.get();
    if (items?.length) {
      items.forEach((envelope) => {
        unreadCount +=
          envelope.readReceipts?.filter(
            (readReceipt) => readReceipt.userId === userId && readReceipt.readAt === null
          ).length ?? 0;
      });
    }

    return unreadCount;
  }
}
